import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MultiFactorAuthComponent } from "../../../../desktop/src/app/pages/authentication/multi-factor-auth/multi-factor-auth.component";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { DomainService } from "./domain.service";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { MfaVerificationComponent } from "../../../../desktop/src/app/pages/authentication/multi-factor-auth/mfa-verification/mfa-verification.component";

@Injectable({
  providedIn: "root",
})
export class MultiFactorService {
  readonly dialog = inject(MatDialog);
  readonly http = inject(HttpClient);
  readonly breakpointObserver = inject(BreakpointObserver);

  constructor() {}

  showMfaSetupModal(data: any) {
    const subscription = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).subscribe((result) => {
      this.dialog.closeAll();
      const isMobile = result.matches;

      const dialogRef = this.dialog.open(MultiFactorAuthComponent, {
        data,
        width: isMobile ? "99vw" : "40vw",
        height: "auto",
        exitAnimationDuration: 0,
      });

      dialogRef.afterClosed().subscribe(() => {
        subscription.unsubscribe();
      });
    });
  }

  showMfaModal(data: any) {
    const subscription = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).subscribe((result) => {
      this.dialog.closeAll();
      const isMobile = result.matches;

      const dialogRef = this.dialog.open(MfaVerificationComponent, {
        data,
        width: isMobile ? "99vw" : "30vw",
        height: "auto",
        exitAnimationDuration: 0,
      });

      dialogRef.afterClosed().subscribe(() => {
        subscription.unsubscribe();
      });
    });
  }

  setupMfaAuth(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.mfaSetup}`, body);
  }

  verifyMfaAuth(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.mfaVerify}`, body);
  }
}
